export default "/images/icon-send.png?2d35597d544f18e4f139497b55814488";